import React from 'react'
import { Flex, Box } from '@chatterbug/aaron'

import Action from 'src/ui/Action/Action'
import routes from 'src/lib/rails-routes/rails-routes'
import { LeaderboardPosition } from 'src/types'
import UserIsOnTop from './subcomponents/UserIsOnTop/UserIsOnTop'
import UserInTheMiddle from './subcomponents/UserInTheMiddle/UserInTheMiddle'
import { t } from 'src/lib/i18n-react'

export type Props = {
  orgName: string
  topUsers: LeaderboardPosition[]
  currentUserPosition: LeaderboardPosition
  orgSize: number
}

const Leaderboard: React.FC<Props> = ({
  orgName,
  topUsers,
  currentUserPosition,
  orgSize,
}) => {
  const isUserOnTop = topUsers?.some(
    (row) => row.user.id === currentUserPosition.user.id
  )

  return (
    <Flex
      flexDirection="column"
      bg="white100"
      boxShadow="overlay"
      p="3x"
      borderRadius="16px"
    >
      <Box as="p" variant="text.paragraph" fontWeight="bold" mb="2x">
        {t('%{orgName} Leaderboard', { orgName })}
      </Box>
      <Flex flexDirection="column">
        {isUserOnTop ? (
          <UserIsOnTop
            topUsers={topUsers}
            orgSize={orgSize}
            currenutUserId={currentUserPosition.user.id}
          />
        ) : (
          <UserInTheMiddle
            topUsers={topUsers}
            orgSize={orgSize}
            currentUserPosition={currentUserPosition}
          />
        )}

        {/* CTA BUTTON */}
        <Box mt="2x">
          <Action href={routes.organizations()}>
            {t('all organization stats')}
          </Action>
        </Box>
      </Flex>
    </Flex>
  )
}

export default Leaderboard
